<template>
  <base-modal height="600"
              :show="show"
              @close="close">
    <div slot="header">
      {{ $t("customContentFilter.title2") }}
    </div>

    <custom-filter-editor ref="customFilterEditor"
                          :mode="fromBus.mode"
                          :mode-id="fromBus.modeId"
                          :child-id="fromBus.childId"
                          :name="fromBus.name"
                          :filter-id="fromBus.filterId"
                          :keywords="fromBus.keywords" />

    <div slot="footer"
         class="footer">
      <custom-filter-navigation :mode="fromBus.mode"
                                :mode-id="fromBus.modeId"
                                :child-id="fromBus.childId"
                                :create-loading="createLoading"
                                :update-loading="updateLoading"
                                :remove-loading="removeLoading"
                                @create="create"
                                @update="update"
                                @remove="remove" />
    </div>
  </base-modal>
</template>

<script>
  import CustomFilterEditor from '@/components/Child/ChildCustomFilter/CustomFilterEditor'
  import CustomFilterNavigation from '@/components/Child/ChildCustomFilter/CustomFilterNavigation'
  import modalMixin from '@/mixins/modalMixin'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      CustomFilterEditor,
      CustomFilterNavigation
    },

    data() {
      return {
        createLoading: false,
        updateLoading: false,
        removeLoading: false,
        fromBus: {
          mode: '',
          modeId: '',
          childId: '',
          filterId: '',
          name: '',
          keywords: []
        }
      }
    },

    methods: {
      create() {
        this.createLoading = true

        this.$refs.customFilterEditor.createFilter()
          .then(() => {
            this.createLoading = false
          })
      },

      update() {
        this.updateLoading = true

        this.$refs.customFilterEditor.updateFilter()
          .then(() => {
            this.updateLoading = false
          })
      },

      remove() {
        this.removeLoading = true

        this.$refs.customFilterEditor.removeFilter()
          .then(() => {
            this.removeLoading = false
          })
      },
    },

    beforeMount() {
      this.setOpenListener('customFiltersEditor')
    }
  }
</script>

<style lang="scss" scoped>
  .footer {
    width: 100%;
    height: 100%;
    padding: 10px 30px;
  }
</style>